<template>
  <section class="page news">
    <article>
      <div class="intro" v-html="content"></div>
      <div class="content" :class="{ hidden: !contentVisible }" v-html="contentScroll"></div>
    </article>
    <site-footer />
  </section>
</template>

<script>
import Footer from '../partials/Footer.vue'
import { mapState } from 'vuex'

export default {

  computed: {
    ...mapState({
      content: state => state.news,
      contentScroll: state => state.newsScroll,

      contentVisible: state => state.filmContentVisible
    })
  },
  components: {
    'site-footer': Footer
  },
  metaInfo: {
    title: 'News'
  }
}
</script>
